/**
 * Composite selection key: "categoryUuid|subCategoryUuid|itemUuid"
 *
 * Uniquely identifies an item placement within a specific category+subcategory
 * slot, so the same food_item_uuid can be selected independently across
 * different categories or subcategories.
 */

export const makeSelectionKey = (
  categoryUuid: string,
  subCategoryUuid: string | null | undefined,
  itemUuid: string,
): string => `${categoryUuid}|${subCategoryUuid ?? ""}|${itemUuid}`;

export const parseSelectionKey = (
  key: string,
): { categoryUuid: string; subCategoryUuid: string | null; itemUuid: string } => {
  const [categoryUuid, subCategoryUuid, itemUuid] = key.split("|");
  return {
    categoryUuid: categoryUuid ?? "",
    subCategoryUuid: subCategoryUuid || null,
    itemUuid: itemUuid ?? "",
  };
};

/** Read the stamped _selectionKey from an item (runtime field, not in IFoodItem type) */
export const getItemSelectionKey = (item: any): string | undefined =>
  item._selectionKey as string | undefined;
